// extracted by mini-css-extract-plugin
export default {"section":"styles_section__Pd77-","inner":"styles_inner__z1xhN","body":"styles_body__XwBUF","aside":"styles_aside__0f0z1"};